import { Button, Card } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

/**
 * Common styled components for the Config page
 */

export const MainContainer = styled(FlexContainer)({
  height: "100%",
  width: "100%",
  overflow: "hidden",
  padding: "10px",
  justifyContent: "flex-start !important",
})

export const SearchContainer = styled(FlexContainer)({
  width: "600px",
  marginTop: "10px",
})

export const DetailCard = styled(Card)({
  padding: "30px",
  width: "700px",
  margin: "20px auto",
  flex: 1,
  overflow: "auto",
  minHeight: 0,
})

export const AddTickerButton = styled(Button)({
  width: "100%",
})

export const CountSpan = styled.span({
  color: SCIENT_COLORS.blue5,
  marginLeft: "4px",
})
